import * as types from "store/types.js";

export const scrubPasswordState = () => {
  return dispatch => {
    dispatch({type: types.CLEAR_PASSWORD_STATE});
  };
};
